














import Vue from 'vue';

export default Vue.extend({
  props: {
    title: String,
    description: String,
    link: String,
  },
  computed: {
    fixedTitle: function() {
      return `Schaut! Ich habe gerade die Lehrstelle ${this.title} auf Industrielehre entdeckt.`;
      //return `Lehrling (m/w/d) - ${this.title} - Jetzt bewerben!`;
    },
  },
});
